import React, { useState, useRef, useEffect } from "react";
import { Radio, Input } from "antd";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import DoubleIcon from "../../assets/double-check.png";
import Editor from "@monaco-editor/react";

import "./resumeResultsCard.scss";

export default function QSetCandidateExamCard({
  qhjid,
  ev_id,
  evalDesc,
  localQDesc,
  index,
  localADesc,
  ansHandler = () => {},
  changeHandler = () => {},
  isSavedHandler = () => {},
  isReviewMode = false,
}) {
  const [editorHeight, setEditorHeight] = useState(0);
  useEffect(() => {
    //console.log("Question Number", index, localQDesc[index])
  }, []);

  const currentQuestion = localQDesc?.[index];
  const currentAnswer = localADesc?.[index];

  const handleOnChange = (e) => {
    localADesc[index].option = e.target.value;
    localADesc[index].localStatus = "Answered";

   // console.log("Given Answer", localADesc[index].option);
    ansHandler([...localADesc]);
    changeHandler(true);
  };

  const handleTextAreaInput = (text) => {
    //console.log("TA Input", text);
    localADesc[index].answer = text;
    ansHandler([...localADesc]);
    changeHandler(true);
  };
  const handleInput = (text) => {
    console.log("Input", text);
    localADesc[index].output = text;
    ansHandler([...localADesc]);
    changeHandler(true);
  };

  const monacoLanguages = [
    { label: "JavaScript", value: "javascript" },
    { label: "TypeScript", value: "typescript" },
    { label: "Java", value: "java" },
    { label: "Python", value: "python" },
    { label: "C++", value: "cpp" },
    { label: "C#", value: "csharp" },
    { label: "Go", value: "go" },
    { label: "PHP", value: "php" },
    { label: "Ruby", value: "ruby" },
    { label: "Swift", value: "swift" },
    { label: "Kotlin", value: "kotlin" },
    { label: "SQL", value: "sql" },
    { label: "HTML", value: "html" },
    { label: "CSS", value: "css" },
    { label: "JSON", value: "json" },
    { label: "Markdown", value: "markdown" },
    { label: "YAML", value: "yaml" },
  ];

  const getMonacoLanguage = () => {
    const skill = localQDesc?.[index]?.skill?.toLowerCase()?.trim();
    if (!skill) return "plaintext";

    const exact = monacoLanguages.find((item) => item.value === skill);
    if (exact) return exact.value;

    const fuzzy = monacoLanguages.find((item) =>
      item.aliases?.some((alias) => skill.includes(alias)),
    );
    return fuzzy ? fuzzy.value : "plaintext"; // never null — always renders
  };

  const enableMonaco = () =>
    localQDesc?.[index]?.questiontype === "Multiple Choice Code";
  const handleEditorDidMount = (editor) => {
    const updateHeight = () => {
      const contentHeight = editor.getContentHeight();
      setEditorHeight(contentHeight);
      editor.layout({
        width: editor.getLayoutInfo().width,
        height: contentHeight,
      });
    };

    updateHeight();

    // Monaco event that fires when content height changes
    editor.onDidContentSizeChange(updateHeight);
  };

  const renderOptionLabel = (text, optionValue) => {
    // If not in review mode (i.e., taking the exam), just return normal text
    if (!isReviewMode) return text;

    // Ensure we are comparing numbers safely
    const correctAnswer = Number(currentQuestion.answer);
    const userAnswer = currentAnswer.option;

    const isCorrectOption = optionValue === correctAnswer;
    const isUserSelectedWrong =
      optionValue === userAnswer && optionValue !== correctAnswer;

    if (isCorrectOption) {
      return (
        <span style={{ color: "#52c41a", fontWeight: "bold" }}>
          {text} <CheckOutlined />
        </span>
      ); // Green
    }

    if (isUserSelectedWrong) {
      return (
        <span style={{ color: "#ff4d4f", fontWeight: "bold" }}>
          {text} <CloseOutlined />
        </span>
      ); // Red
    }

    // Default return for unselected/neutral options
    return <span style={{ color: "#d9d9d9" }}>{text}</span>;
  };

  return (
    <div className="qsetQuestionsCard-wrapper">
      <div className="examCard-name">
        <div className="examCard-name-row">
          <div className="item">{localQDesc?.[index]?.assessmenttype}</div>
          <div className="item">{localQDesc?.[index]?.skill}</div>
        </div>

        {isSavedHandler(index) == false ? (
          <></>
        ) : (
          <>
            <div className="examCard-name-icon">
              <img
                src={DoubleIcon}
                alt="AI"
                width="14"
                height="14"
                className="image"
              />
            </div>
          </>
        )}
      </div>
      <div className="qsetCard-heading">
        {index + 1}. {localQDesc?.[index]?.question}
      </div>
      {enableMonaco() ? (
        <>
          <div className="qsetCard-heading">
            <Editor
              height={editorHeight}
              defaultLanguage={getMonacoLanguage()}
              value={localQDesc?.[index]?.multiplechoicecode}
              onMount={handleEditorDidMount}
              options={{
                readOnly: true,
                minimap: { enabled: false },
                automaticLayout: true,
                scrollBeyondLastLine: false,
              }}
            />
          </div>
        </>
      ) : (
        <></>
      )}
      {localQDesc?.[index]?.questiontype == "Multiple Choice Code" ? (
        <>
          <div className="resumeResultsCard-current">
            <Radio.Group
              style={{ display: "flex", flexDirection: "column", gap: 20 }}
              onChange={handleOnChange}
              value={currentAnswer.option}
              options={[
                { value: 1, label: localQDesc?.[index]?.optiona },
                { value: 2, label: localQDesc?.[index]?.optionb },
                { value: 3, label: localQDesc?.[index]?.optionc },
                { value: 4, label: localQDesc?.[index]?.optiond },
              ]}
            />
          </div>
        </>
      ) : localQDesc?.[index]?.questiontype == "Multiple Choice" ? (
        <>
          <div className="resumeResultsCard-current">
            <Radio.Group
              style={{ display: "flex", flexDirection: "column", gap: 20 }}
              onChange={handleOnChange}
              value={currentAnswer.option}
              options={[
                // 3. Wrap your labels in the helper function
                {
                  value: 1,
                  label: renderOptionLabel(currentQuestion.optiona, 1),
                },
                {
                  value: 2,
                  label: renderOptionLabel(currentQuestion.optionb, 2),
                },
                {
                  value: 3,
                  label: renderOptionLabel(currentQuestion.optionc, 3),
                },
                {
                  value: 4,
                  label: renderOptionLabel(currentQuestion.optiond, 4),
                },
              ]}
            />
          </div>
        </>
      ) : localQDesc?.[index]?.questiontype == "True/False" ? (
        <>
          <Radio.Group
            style={{ display: "flex", flexDirection: "column", gap: 20 }}
            onChange={handleOnChange}
            value={currentAnswer.option}
            options={[
              { value: 1, label: "True" },
              { value: 2, label: "False" },
            ]}
          />
        </>
      ) : localQDesc?.[index]?.questiontype == "Text Input" ? (
        <>
          <div className="resumeResultsCard-current">
            <TextArea onChange={handleTextAreaInput} />
          </div>
        </>
      ) : localQDesc?.[index]?.questiontype == "Coding" ? (
        <>
          <TextArea onChange={handleTextAreaInput} />
          <div className="qsetCard-heading">Output</div>
          <Input onChange={handleInput} />
        </>
      ) : (
        <></>
      )}
    </div>
  );
}
